/*
 * Hide the "(Mix and match) You must select at least 12 products" notice
 * once the cart total reaches the minimum (12), per client request.
 * The Sami order-limit notice shows per line item even when the mix-and-match
 * TOTAL is already met; this hides it whenever the cart total is >= MIN_QTY.
 */
(function () {
  var MIN_QTY = 12;
  var NOTICE_RE = /you must select at least|\(mix and match\)/i;
  var lastTotal = 0;

  function apply() {
    var hide = lastTotal >= MIN_QTY;
    var nodes = document.querySelectorAll('div, p, span, li');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = (el.textContent || '').trim();
      if (t.length > 140 || !NOTICE_RE.test(t)) continue;
      // Climb to the notice "box" but stop before we reach the whole line item
      var box = el;
      for (var j = 0; j < 3 && box.parentElement; j++) {
        var pt = (box.parentElement.textContent || '').trim();
        if (pt.length > t.length + 30) break; // parent holds other content -> stop
        box = box.parentElement;
      }
      box.setAttribute('data-tt-moq-notice', '1');
      box.style.display = hide ? 'none' : '';
    }
  }

  function refresh() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      lastTotal = c.item_count || 0;
      apply();
    }).catch(function () {});
  }

  // Re-apply instantly on DOM changes (cheap, no fetch), refresh the total periodically
  new MutationObserver(function () { apply(); }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(refresh, 1500);
  refresh();
})();